const employeeRedirect = async (axios, history, prevLocation, message) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/employees/employee/profile`,
      { headers: { token } }
    );
    if (response.status === 200 && response.data.data.status === "accepted") {
      return history.push(
        prevLocation || `/dashboard/s/${response.data.data.school.uuid}`
      );
    }
    if (response.status === 200 && response.data.data.status === "rejected") {
      return history.push(prevLocation || `/user/${response.data.data.uuid}`);
    }
    return history.push({
      pathname: `/employees/invitation/${response.data.data.uuid}/${response.data.data.school.uuid}`,
      search: `?schoolName=${response.data.data.school.schoolName.replaceAll(
        " ",
        "+"
      )}&role=${response.data.data.user.role}`,
    });
  } catch (error) {
    if (error.message === "Network Error") {
      return message.error(error.message);
    }
    if (error?.response?.status === 404) {
      return message.error(error.response.data.error);
    }
    if (error?.response?.status === 500) {
      return message.error(error.response.data.error);
    }
  }
};
export default employeeRedirect;